import OpenLink from '../../images/Portfolio2OpenLink.png';
import ProjectImage from '../../images/Portfolio2ProjectImage.png';

function Project({genre, title, link,video,desc, image,hooks}) {
  return (
    <div className = 'works-content-content-projects-project'>
      <div className = "works-content-content-projects-project-info">
        <span className = "works-content-content-projects-project-info-type">{genre}</span>
        <span className = "works-content-content-projects-project-info-title">{title}</span>
        <span className = "works-content-content-projects-project-info-desc">{desc}</span>
        <button onClick={() => {if(video != null){hooks.setvideoOpen(true);hooks.setcurrentVideo(video);} else if(link != null) {window.open(link,'_blank');}}} className = 'works-content-content-projects-project-info-button'></button>
      </div>
      <div className = 'works-content-content-projects-project-image'>
        <img src = {image} className = "works-content-content-projects-project-image-img"/>
      </div>
    </div>
  );
}

export default Project;